import Actions                     from 'Redux/Actions';
import { EventCategoryRepository } from 'Domain/Repositories';
import { ofType }                  from 'redux-observable';
import { from, EMPTY }             from 'rxjs';
import { mergeMap }                from 'rxjs/operators';
import { TEpic }                   from 'Redux/Config';

export const findEventCategoryEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.findEventCategoryRequest.type),
    mergeMap(action => {
      const { id } = action.payload;

      if (!id.trim()) {
        return EMPTY;
      }

      return from(
        EventCategoryRepository.findById(id)
          .then((eventCategory) => Actions.findEventCategorySuccess({ eventCategory }))
          .catch(error => Actions.findEventCategoryFailure({ error })),
      );
    }),
  );
};
